import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoComboBoxMixin from './KendoComboBoxMixin'

export default {
    name: 'kendo-combobox',
    mixins: [ KendoComboBoxMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        return h('input', [
            this.$slots['kendo-datasource']
        ])
    },
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoComboBox/index.js